import IconBase from "react-icon-base";
import React from "react";

export default function Icon(props) {
  return (
    <IconBase
      {...props}
      viewBox={"0 0 24 24"}
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="UTF-8" standalone="no"?><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"><svg width="100%" height="100%" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"><g><path d="M31.68,21.932l-14.943,-14.942c-0.213,-0.214 -0.459,-0.321 -0.737,-0.321c-0.278,0 -0.524,0.107 -0.737,0.321l-14.942,14.942c-0.214,0.214 -0.321,0.46 -0.321,0.738c0,0.278 0.107,0.524 0.321,0.737l1.603,1.603c0.213,0.214 0.459,0.321 0.737,0.321c0.278,0 0.524,-0.107 0.738,-0.321l12.601,-12.601l12.602,12.602c0.214,0.214 0.46,0.32 0.737,0.32c0.279,0 0.525,-0.107 0.738,-0.32l1.603,-1.604c0.214,-0.213 0.32,-0.459 0.32,-0.737c0,-0.278 -0.106,-0.524 -0.32,-0.738Z" style="fill-rule:nonzero;"/></g></svg>`,
      }}
    />
  );
}
